import mqtt from 'mqtt'

class MqttClient {
  constructor(brokerUrl, options = {}) {
    this.client = mqtt.connect(brokerUrl, options)
    this.handlers = {}

    this.client.on('message', (topic, message) => {
      if (this.handlers[topic]) {
        this.handlers[topic].forEach(handler => handler(message.toString(), topic))
      }
    })
  }

  subscribe(topic, handler) {
    if (!this.handlers[topic]) {
      this.handlers[topic] = []
      this.client.subscribe(topic)
    }
    this.handlers[topic].push(handler)
  }

  unsubscribe(topic, handler) {
    if (this.handlers[topic]) {
      this.handlers[topic] = this.handlers[topic].filter(h => h !== handler)
      if (this.handlers[topic].length === 0) {
        this.client.unsubscribe(topic)
        delete this.handlers[topic]
      }
    }
  }

  end() {
    this.client.end()
  }
}

export default MqttClient
